var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FETCH_STORES_API } from "../constants/api-endpoints";
import { makeApiCall } from "./apiHelper";
import { getResourceKeys } from "./permissionsUtils";
export var PERMISSION_SCOPED_STORE_LIST_PAGE_SIZE = 100;
/*
@desc This function fetches the list of stores that the user has access to based on the permission string
Usage Example:
const response = await fetchPermissionScopedStoreListFromLib({
  permissionString,
  pageSize,
  pageNumber,
});

PermissionString should will be `${action}:${module} permissions separated by comma.
E.g.: get:insight,create:insight,update:insight,get:finance

Example of Request Payload:
permissions: get:insight,get:finance
page_size: 100
page_number: 0
*/
export var fetchPermissionScopedStoreList = function (_a) {
    var permissionString = _a.permissionString, _b = _a.pageSize, pageSize = _b === void 0 ? PERMISSION_SCOPED_STORE_LIST_PAGE_SIZE : _b, _c = _a.pageNumber, pageNumber = _c === void 0 ? 0 : _c;
    return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, makeApiCall({
                        url: FETCH_STORES_API,
                        method: "GET",
                        headers: {
                            "x-mex-resource": getResourceKeys(),
                            "x-mex-version": "v2",
                        },
                        params: {
                            permissions: permissionString,
                            page_size: pageSize,
                            page_number: pageNumber,
                        },
                    })];
                case 1:
                    response = _d.sent();
                    return [2 /*return*/, response];
            }
        });
    });
};
//# sourceMappingURL=storeSelectorHelper.js.map